module.exports = __webpack_public_path__ + "img/employees.c41dcd94.svg";